import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-vertical-title',
  templateUrl: './vertical-title.component.html',
  styleUrls: ['./vertical-title.component.scss']
})
export class VerticalTitleComponent implements OnInit {

  @Input() title = '';
  @Input() subTitle = '';

  constructor() {
  }

  ngOnInit(): void {
  }

}
